import { createFileRoute, notFound } from '@tanstack/react-router';
import { guideOf } from '../screens/developers/guides/registry';

/** Public: one developer guide by its slug (processing-modes, results, webhooks, errors, limits). */
export const Route = createFileRoute('/developers/$guide')({
  loader: ({ params }) => {
    if (!guideOf(params.guide)) throw notFound();
  },
  component: GuideRoute,
});

function GuideRoute() {
  const { guide } = Route.useParams();
  const Page = guideOf(guide)!.Page;
  return <Page />;
}
